module.exports = __webpack_public_path__ + "static/media/golf-icon.6ab1b948.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/golf-icon.svg
// module id = 39
// module chunks = 0